import { createFileRoute } from "@tanstack/react-router";
import {
	formTabSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/full/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.jobTypeId,
			to: "/org-admin/$orgId/configuration/jobTypes/$jobTypeId/full",
			params: { orgId: params.orgId, jobTypeId: params.jobTypeId },
			search: formTabSearch(search),
		});
	},
	component: () => null,
});
